exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1YzJy {\n  height: 340px;\n  overflow: auto;\n  padding: 20px;\n}\n.s1jG3 {\n  text-align: center;\n  padding: 15px;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "_1YzJy",
	"button": "s1jG3"
};